module.exports = __webpack_public_path__ + "img/keyboard-3085978_1280.c18e3da5.jpg";